import { NgModule } from '@angular/core';
import { DirectivesModule } from '@freelancer/directives';
import { AiConsultantComponent } from 'app/ai-consultant/ai-consultant.component';
import { CompatAiConsultantComponent } from './compat-ai-consultant.component';

@NgModule({
  imports: [AiConsultantComponent, DirectivesModule],
  declarations: [CompatAiConsultantComponent],
})
export class CompatAiConsultantModule {}
